(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blun-before-after"] && !Shopify.designMode) return;
  try {
    
  class BlunBeforeAfter extends HTMLElement {
    connectedCallback() {
      const range = this.querySelector('.blun-ba__range');
      if (!range) return;
      const apply = () => this.style.setProperty('--x', `${range.value}%`);
      range.addEventListener('input', apply);
      apply();
    }
  }

  if (!customElements.get('blun-before-after')) {
    customElements.define('blun-before-after', BlunBeforeAfter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blun-bundle"] && !Shopify.designMode) return;
  try {
    
  class BlunBundle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.blun-bundle__btn');
      this.label = this.querySelector('.blun-bundle__btn-label');
      if (!this.button) return;
      this.defaultLabel = this.label.textContent;
      this.button.addEventListener('click', () => this.add());
    }

    async add() {
      const a = this.dataset.variantA;
      const b = this.dataset.variantB;
      if (!a || !b) return;

      this.button.disabled = true;
      this.label.textContent = 'Adding…';

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(a), quantity: 1 },
              { id: Number(b), quantity: 1 },
            ],
          }),
        });

        if (!response.ok) throw new Error(await response.text());

        // Send the shopper to the cart so the automatic discount is visible
        // immediately — a silent drawer update hides the saving they were promised.
        window.location.href = '/cart';
      } catch (error) {
        console.error('Bundle add to cart failed', error);
        this.button.disabled = false;
        this.label.textContent = 'Could not add — try again';
        setTimeout(() => {
          this.label.textContent = this.defaultLabel;
        }, 2500);
      }
    }
  }

  if (!customElements.get('blun-bundle')) {
    customElements.define('blun-bundle', BlunBundle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blun-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var groups = document.querySelectorAll('[data-faq-accordion]');
    groups.forEach(function (group) {
      var rows = group.querySelectorAll('details.blun-faq__row');
      rows.forEach(function (row) {
        row.addEventListener('toggle', function () {
          if (!row.open) return;
          rows.forEach(function (other) {
            if (other !== row && other.open) {
              other.open = false;
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blun-for-you"] && !Shopify.designMode) return;
  try {
    
  class BlunFySlider extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.blun-fy__slide')];
      if (this.slides.length < 2) return;
      this.i = 0;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const advance = () => {
        this.slides[this.i].classList.remove('is-active');
        this.i = (this.i + 1) % this.slides.length;
        this.slides[this.i].classList.add('is-active');
      };
      this.timer = setInterval(advance, 4000);

      this.onVis = () => {
        if (document.hidden) clearInterval(this.timer);
        else this.timer = setInterval(advance, 4000);
      };
      document.addEventListener('visibilitychange', this.onVis);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVis);
    }
  }

  (function () {
    var section = document.currentScript ? document.currentScript.closest('.shopify-section') : null;
    var root = section || document;
    var dlg = root.querySelector('[data-fy-dialog]');
    if (!dlg || !dlg.showModal) return;
    var img = dlg.querySelector('[data-fy-zoom-img]');
    var title = dlg.querySelector('[data-fy-zoom-title]');
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-fy-zoom]');
      if (btn) {
        img.src = btn.dataset.fyZoom;
        img.alt = btn.dataset.fyTitle;
        title.textContent = btn.dataset.fyTitle;
        dlg.showModal();
        return;
      }
      if (e.target.closest('[data-fy-close]')) dlg.close();
      if (e.target === dlg) dlg.close();
    });
  })();

  if (!customElements.get('blun-fy-slider')) {
    customElements.define('blun-fy-slider', BlunFySlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blun-products"] && !Shopify.designMode) return;
  try {
    
  class BlunBundleCta extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.blun-both__btn');
      this.error = this.querySelector('.blun-both__err');
      if (!this.button) return;
      this.button.addEventListener('click', () => this.addBoth());
    }

    async addBoth() {
      const a = this.dataset.variantA;
      const b = this.dataset.variantB;
      if (!a || !b) return;

      const label = this.button.textContent;
      this.button.disabled = true;
      this.button.textContent = 'Adding…';
      if (this.error) this.error.hidden = true;

      try {
        // Ek hi request mein dono lines, taake cart aadha na bhare.
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [
              { id: Number(a), quantity: 1 },
              { id: Number(b), quantity: 1 },
            ],
          }),
        });
        if (!res.ok) throw new Error(await res.text());
        // Saving Automatic Discount hai, cart par lagti hai.
        window.location.href = '/cart';
      } catch (e) {
        this.button.disabled = false;
        this.button.textContent = label;
        if (this.error) {
          this.error.textContent = 'Sorry, that could not be added. Please try again.';
          this.error.hidden = false;
        }
      }
    }
  }

  if (!customElements.get('blun-bundle-cta')) {
    customElements.define('blun-bundle-cta', BlunBundleCta);
  }

  /* Add to bag buttons: product page nahi khulta, sirf cart mein add hota hai. */
  (function () {
    if (window.__blunProdAddBound) return;
    window.__blunProdAddBound = true;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var timer;

    function showToast(scope, msg) {
      var el = scope.querySelector('[data-blun-toast]');
      if (!el) return;
      el.textContent = msg;
      el.classList.add('is-visible');
      clearTimeout(timer);
      timer = setTimeout(function () {
        el.classList.remove('is-visible');
      }, 2600);
    }

    function updateCount(cart) {
      document
        .querySelectorAll(
          'cart-icon .cart-bubble__text-count, .cart-count-bubble span[aria-hidden], [data-cart-count]'
        )
        .forEach(function (n) {
          n.textContent = cart.item_count;
        });
      try {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'blun-prod',
              data: { source: 'blun-prod', itemCount: cart.item_count }
            }
          })
        );
      } catch (e) {}
    }

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-blun-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();

      var scope = btn.closest('.blun-prod-section') || document;
      var id = Number(btn.getAttribute('data-variant-id'));
      var label = btn.getAttribute('data-label') || 'Add to bag';

      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error(data.description || data.message || 'Could not add');
            return data;
          });
        })
        .then(function () {
          return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          updateCount(cart);
          showToast(scope, 'Added to bag');
        })
        .catch(function (err) {
          showToast(scope, err.message || 'Could not add to bag');
        })
        .then(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blun-vsl"] && !Shopify.designMode) return;
  try {
    
  class BlunVideo extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      const button = this.querySelector('.blun-vsl__play');
      if (!video || !button) return;

      button.addEventListener('click', () => {
        button.hidden = true;
        video.play();
      });

      // If the viewer scrubs or pauses, leave the native controls in charge —
      // the overlay is only ever the initial affordance.
      video.addEventListener('play', () => {
        button.hidden = true;
      });
    }
  }

  if (!customElements.get('blun-video')) {
    customElements.define('blun-video', BlunVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
